export function check_roles(good_roles=[]){

    try{
        var user_data = JSON.parse(localStorage.getItem("user_data"))
        if(!user_data){
            user_data = {}
        }
    }catch(e){ 
        var user_data = {}
    }

    //good_roles.push("admin")
    var roles = []
    if(user_data.roles && user_data.roles.length){
        roles = user_data.roles
    }
     
    return good_roles.some(v=> roles.indexOf(v) !== -1) 
}